/* eslint-disable */
import React, { Component, createRef } from 'react';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { isMobile  } from 'react-device-detect';
import SSOFT_HELP_HERO_936 from '../../sections/SSoft_Help_Hero_936/SSoft_Help_Hero';
import SSOFT_CONTACT_US_FORM_959 from '../../sections/SSoft_Contact_Us_Form_959/SSoft_Contact_Us_Form';
import SSOFT_FAQ_1348 from '../../sections/SSoft_FAQ_1348/SSoft_FAQ';
import SSOFT_OUR_OFFICES_960 from '../../sections/SSoft_Our_Offices_960/SSoft_Our_Offices';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class project1 extends Component {
   constructor(props) {
       super(props);
       this.state = {
           currentPage: null,
           currentSection: null,
           override: true,
           section: [
               { id: 1, slug: localStorage.getItem('language') === "English"? 'hero-of-the-help-pages' : 'hero-of-the-help-pages'},
               { id: 2, slug: localStorage.getItem('language') === "English"? 'contac-us-form' : 'contac-us-form'},
               { id: 3, slug: localStorage.getItem('language') === "English"? 'faq' : 'faq'},
               { id: 4, slug: localStorage.getItem('language') === "English"? 'our-location' : 'our-location'},
           ],
       };
       this.scrollToSection = this.scrollToSection.bind(this);
       this.scrollAction = this.scrollAction.bind(this);
        this.isStateChanging = false
   }
   componentDidMount() {
       this.scrollToSection();
       ReactGA.initialize('')
       ReactGA.pageview(window.location.pathname + window.location.search);
   }
   componentWillUnmount(){
   }
   section1 = createRef()
   section2 = createRef()
   section3 = createRef()
   section4 = createRef()
   scrollToSection() {
       let currentLocation = window.location.href
       const hasSectionAnchor = currentLocation.includes('/#')
       if (hasSectionAnchor) {
           let anchorSectionId = `${currentLocation.substring(currentLocation.indexOf('#') + 1)}`
           setTimeout(() => { this.scrollAction(anchorSectionId) }, 1000)
       }
   }
   scrollAction(anchorSectionId) {
       const uri_dec = decodeURIComponent(anchorSectionId)
       const key = this.state.section.filter(x => x.slug == uri_dec).map(obj => `section${obj.id}`)
       const getY = (element) => element.getBoundingClientRect().top + window.pageYOffset - 140;
       if (key) {
          if (key[0] === 'section1') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section1.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section2') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section2.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section3') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section3.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section4') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section4.current), behavior: 'smooth' })}, 1000)
            }
       }
   }
   render() {
       const getHelmetTitle = () => {
           var title;
           switch (localStorage.getItem('language')) {
               case 'English':
                   title = <title> Contact | Supersoft</title>;
                   break;
               case 'Indonesian':
                   title = <title> Kontak | Supersoft</title>;
                   break;
               default:
                   title = <title> Contact | Supersoft</title>;
                   break;
           }
           return title;
       };
       const getHelmetDescription = () => {
           var description;
           switch (localStorage.getItem('language')) {
               case 'English':
                   description = <meta name='description' content='Contact - PT Supersoft' />;
                   break;
               case 'Indonesian':
                   description = <meta name='description' content='Kontak - PT Supersoft' />;
                   break;
               default:
                   description = <meta name='description' content='Contact - PT Supersoft' />;
                   break;
           }
           return description;
       };
       const getHelmetKeywords = () => {
           var keywords;
           switch (localStorage.getItem('language')) {
               case 'English':
                   keywords = <meta name='keywords' content='' />;
                   break;
               case 'Indonesian':
                   keywords = <meta name='keywords' content='' />;
                   break;
               default:
                   keywords = <meta name='keywords' content='' />;
                   break;
           }
           return keywords;
       };
         let helmet = getHelmetTitle();
         let description = getHelmetDescription();
         let keywords = getHelmetKeywords();
       return (
           <>
               <Helmet>
                   {helmet}
                   {description}
                   {keywords}
               </Helmet>
            <div ref={this.section1}>
                <SSOFT_HELP_HERO_936 />
            </div>
            <div ref={this.section2}>
                <SSOFT_CONTACT_US_FORM_959 />
            </div>
            <div ref={this.section3}>
                <SSOFT_FAQ_1348 />
            </div>
            <div ref={this.section4}>
                <SSOFT_OUR_OFFICES_960 />
            </div>
           </>
       );
   }
}
export default withParams(project1);